import RestClient from './RestClient';
import { Screening } from '../../models';
import i18n from '../../locales/i18n';
import store from '../../redux';
import { getRequestInstanceQueryValue } from '../requestInstance';

class Screenings extends RestClient {
    constructor() {
        super({
            "model": Screening,
            "id_field": "_id",
            "entryPoint": "screening",
            "resource": "screening",
            "resources": "screenings"
        });

        this.TKTSYNC_PATH = '/tktsync';
    }

    icsLink(params) {
        const link = new URL(`${this.baseUrl}/screening/ics`);
        const user = store.getState().auth.user;
        if (user?.api_key)
            link.searchParams.append('x-api-key', user.api_key);

        const tkt_instance = getRequestInstanceQueryValue();
        if (tkt_instance)
            link.searchParams.append('tkt_instance', tkt_instance);

        if (!params)
            return link.href;

        if (params.lang)
            link.searchParams.append('lang', params.lang);

        if (params.places_ids) {
            const ids = Array.isArray(params.places_ids)
                ? params.places_ids.filter(Boolean).join(',')
                : String(params.places_ids);
            if (ids)
                link.searchParams.append('places_ids', ids);
        }

        // Subscription must keep receiving upcoming séances (Engine default
        // `stop_at >= now`). Do not copy the list date window.

        return link.href;
    }

    tktsync() {
        return this.POST(`/${this.entryPoint}${this.TKTSYNC_PATH}`, {})
            .then(response => response.json())
            .then(json => {
                if (json.imported)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    /**
     * Screening ctor always materializes defaults (opaque flags, empty
     * refs/buckets). Only send those fields when the caller explicitly
     * included them; otherwise Kore replaces existing data (cine.ch refs,
     * etc.) — including on the general-tab save, which does not edit refs.
     */
    finalizeUpdatePayload(submitted, prepared) {
        if (!submitted || typeof submitted !== 'object')
            return prepared;
        if (!Object.prototype.hasOwnProperty.call(submitted, 'opaque'))
            delete prepared.opaque;
        if (!Object.prototype.hasOwnProperty.call(submitted, 'refs'))
            delete prepared.refs;
        if (!Object.prototype.hasOwnProperty.call(submitted, 'buckets'))
            delete prepared.buckets;
        return prepared;
    }

    updateScreeningProperty(payload) {
        let prepared = new Screening(payload);
        if ('prepareForUpdate' in prepared)
            prepared = prepared.prepareForUpdate();
        prepared = this.finalizeUpdatePayload(payload, prepared);

        return this.PUT(
            `/screening/update/id/${payload._id}`,
            { lang: i18n.language, "screening": prepared }
        ).then(response => response.json())
        .then(json => {
            if (json[this.resource]) {
                json[this.resource] = new this.model(json[this.resource]);
                return json;
            }
            throw new Error(json.flash.error);
        });
    }
}

const ScreeningsApi = new Screenings();

export default ScreeningsApi;
